<template>
  <div class="bg-white">
    <div class="relative isolate overflow-hidden bg-gradient-to-b from-indigo-100/20">
      <div class="mx-auto max-w-7xl pb-24 sm:pb-32 lg:grid lg:grid-cols-3 lg:gap-x-8 lg:px-8 lg:py-20">
        <div class="px-6 lg:px-0 lg:pt-4">
          <div class="mx-auto max-w-2xl">
            <div class="max-w-lg">
              <h1 class="mt-1 text-2xl font-bold tracking-tight text-gray-800 sm:text-4xl">Start Here</h1>
              <p class="mt-6 text-lg leading-8 text-gray-600">Execute Tests or Analyze your Data by creating Scenario, setting up Job to run the Scenario, executing your Jobs and Reviewing the Results.</p>
              <div class="mt-10 flex items-center gap-x-6">
                <a
                  href="https://docs.enegel.ai"
                  target="_blank"
                  class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >Documentation</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="mt-20 sm:mt-24 md:mx-auto md:max-w-2xl lg:mx-0 lg:mt-0 lg:col-span-2">
          <div class="absolute inset-y-0 right-1/2 -z-10 -mr-10 w-[200%] skew-x-[-30deg] bg-white shadow-xl shadow-indigo-600/10 ring-1 ring-indigo-50 md:-mr-20 lg:-mr-36" aria-hidden="true" />
          <div class="md:rounded-3xl">
            <div class="">
              <div class="absolute -inset-y-px left-1/2 -z-10 ml-10 w-[200%] skew-x-[-30deg] bg-indigo-100 opacity-40 ring-1 ring-inset ring-white md:ml-20 lg:ml-36" aria-hidden="true" />
              <div class="relative px-2 pt-8 sm:pt-8 md:pl-8 md:pr-0">
                <div class="mx-auto max-w-2xl md:mx-0 md:max-w-2xl">
                  <div class="overflow-hidden rounded-tl-xl">
                    <start-here-steps></start-here-steps>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="absolute inset-x-0 bottom-0 -z-10 h-24 bg-gradient-to-t from-white sm:h-32" />
    </div>
  </div>
</template>

<script setup>
  import StartHereSteps from '@/components/StartHereSteps.vue';

  // This shows how to load a list of files from disk
  //const mdFiles = import.meta.glob('@/data/**/*.md', { as: 'raw', eager: true });
  //for (const mdf in Object.keys(mdFiles)) {
  //  console.log(`MD File: ${mdf}`);
  //}
</script>
